// extracted by mini-css-extract-plugin
export var menuIcon = "_s4-0";
export var menuIconInline = "_s4-1";